export interface SeoData {
  title: string;
  description: string;
  keywords?: string;
  canonical?: string;
  ogType?: string;
  ogImage?: string;
  twitterCard?: string;
  twitterImage?: string;
}

export const SITE_URL =
  (import.meta.env.VITE_SITE_URL as string) || 'https://allchinabuyspread.org.uk';

export const SITE_NAME = 'AllChinaBuy Spreadsheet';

export const FAVICON_URL =
  'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/49750b7389edabeda6497a215e0702e5.png';

export const HERO_IMAGE =
  'https://readdy.ai/api/search-image?query=A%20modern%20minimalist%20flat%20lay%20of%20sneakers%2C%20hoodies%2C%20caps%2C%20backpacks%20and%20accessories%20neatly%20arranged%20on%20a%20soft%20cream%20pastel%20background%2C%20soft%20natural%20light%2C%20clean%20aesthetic%2C%20editorial%20product%20photography%20with%20gentle%20shadows%2C%20warm%20neutral%20tones%2C%20high%20detail%20harmonious%20composition&width=1600&height=900&seq=hero-allchinabuy-01&orientation=landscape';

function upsertMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertLink(rel: string, href: string) {
  let el = document.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

export function applySeo(data: SeoData) {
  document.title = data.title;

  upsertMeta('name', 'description', data.description);
  if (data.keywords) upsertMeta('name', 'keywords', data.keywords);
  if (data.canonical) upsertLink('canonical', data.canonical);

  upsertMeta('property', 'og:title', data.title);
  upsertMeta('property', 'og:description', data.description);
  if (data.canonical) upsertMeta('property', 'og:url', data.canonical);
  if (data.ogType) upsertMeta('property', 'og:type', data.ogType);
  if (data.ogImage) upsertMeta('property', 'og:image', data.ogImage);

  upsertMeta('name', 'twitter:card', data.twitterCard || 'summary_large_image');
  upsertMeta('name', 'twitter:title', data.title);
  upsertMeta('name', 'twitter:description', data.description);
  if (data.twitterImage) upsertMeta('name', 'twitter:image', data.twitterImage);
}